<div class="link-container">
  @for (link of href; track $index) {
    <a class="search-highlight" [class.icon]="link.icon" [href]="link.link" [innerHTML]="(link.icon ? createIconElement(link.icon) : link.value) | iconReplace"></a>
  }
  @for (link of routes; track $index) {
    <a
      class="search-highlight"
      [class.icon]="link.icon"
      [routerLink]="['/app/content', link.link]"
      [innerHTML]="(link.icon ? createIconElement(link.icon) : link.value) | iconReplace"
    ></a>
  }
  @if (!href.length && !routes.length) {
    <label class="search-highlight" [innerHTML]="value"></label>
  }
</div>
